import { Component, EventEmitter, Input, Output, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { AppIcons } from 'app/modules/shared/app.icons';

@Component({
  selector: 'app-patient-selection-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    TableModule,
    InputTextModule,
    TranslateModule
  ],
  templateUrl: './patient-selection-dialog.component.html',
  styleUrls: ['./patient-selection-dialog.component.scss']
})
export class PatientSelectionDialogComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() productIndex: number = -1;
  @Input() protocolEntityId: string;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onSaveSelection = new EventEmitter<{ index: number, patients: any[] }>();
  patientFilterList: any[] = [];
  entityData = {
    forTenantCode: this.configService.getForTenantCode(),
    entityCode: AppSettings.ENTITY_CODE.PATIENT,
    countryCode: AppSettings.HEADER_COUNTRY_CODE,
    limit: 100,
    offset: 0,
    filters: [],
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
  };
  miIcons = AppIcons;

  @Input() set selectedPatients(value: any[]) {
    this.internalSelectedPatients = value ? [...value] : [];
  }
  get selectedPatients() {
    return this.internalSelectedPatients;
  }
  private internalSelectedPatients: any[] = [];

  availablePatients: any[] = [];
  availablePatientSearch: string = '';
  selectedPatientSearch: string = '';

  get filteredAvailablePatients() {
    if (!this.availablePatientSearch) return this.availablePatients;
    return this.availablePatients.filter(p => p.name.toLowerCase().includes(this.availablePatientSearch.toLowerCase()));
  }

  get filteredSelectedPatients() {
    if (!this.selectedPatientSearch) return this.selectedPatients;
    return this.selectedPatients.filter(p => p.name.toLowerCase().includes(this.selectedPatientSearch.toLowerCase()));
  }

  constructor(
    private entityService: EntityService,
    private configService: ConfigService,
    private cs: CommonBindingDataService
  ) { }

  ngOnInit() {
    this.loadPatients();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.protocolEntityId) {
      this.loadPatients();
    }
  }

  loadPatients() {

    this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.PROTOCOL_PATIENT, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(
      (data: any) => {
        this.patientFilterList = this.cs.getColumns(data);
        this.entityData.filters = [{
          attributeId: this.patientFilterList.find(field => field.attributeCode === 'protocol_entity_id')?.attributeId,
          attributeValue: this.protocolEntityId
        }, {
          attributeId: this.patientFilterList.find(field => field.attributeCode === 'patient_status')?.attributeId,
          attributeValue: 'On Trial'
        }];
        this.entityService.searchEntity(AppSettings.ENTITY_CODE.PROTOCOL_PATIENT, this.entityData, true).subscribe((res: any) => {
          const data = this.cs.getTableData(res);
          this.availablePatients = data.map((item: any) => ({
            id: item.id,
            name: item.patient_id || ''
          }));
        });
      }
    );


  }

  removePatient(patient: any) {
    this.internalSelectedPatients = this.internalSelectedPatients.filter(p => p.id !== patient.id);
  }

  clearAvailablePatientSearch() {
    this.availablePatientSearch = '';
  }

  clearSelectedPatientSearch() {
    this.selectedPatientSearch = '';
  }

  onCancel() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onSave() {
    this.onSaveSelection.emit({
      index: this.productIndex,
      patients: this.selectedPatients
    });
    this.visible = false;
    this.visibleChange.emit(false);
  }
} 